export default __webpack_public_path__ + "static/media/DunwichHorror.6804e508.jpg";